export default "/assets/images/basic-breather-crop.19bfc590a64cb73d.webp";